export default __webpack_public_path__ + "static/coinbase-feature-48f6c8972e8927bce890e5fbca13be00.webp";